import { ErrorIcon } from "assets";
import { JSX } from "react";
interface ErrorProps {
  children: React.ReactNode;
}
export default function Error({ children }: ErrorProps): JSX.Element {
  return (
    <>
      <p className="text-red-500 text-xs mt-1 flex items-center">
        <ErrorIcon  className="mr-1 size-3" />
        {children}
      </p>
    </>
  );
}
